// Reports Hub (Report Builder viewer). Access is enforced server-side (rbViewer + per-report
// visibility/user types). No client route `permission` on purpose: the router guard evaluates
// before perms finish loading, which would bounce a page refresh back to Home.
let mainPath = "/report-hub";
// static import paths on purpose: a path built from a variable makes webpack bundle every views/*/Index.vue into one lazy context

module.exports = [
    {
        path: mainPath,
        name: 'Reports Hub',
        component: () => import(/* webpackChunkName: "rb-hub" */ '../views/ReportsHub/Index.vue'),
    },
    {
        path: mainPath+'/:key',
        name: 'Report View',
        component: () => import(/* webpackChunkName: "rb-hub-run" */ '../views/ReportsHub/Run.vue'),
    },
    {
        // underlying ("base") data of a report, opened in its own tab with the report's filters
        path: mainPath+'/:key/data/:drill',
        name: 'Report Data',
        component: () => import(/* webpackChunkName: "rb-hub-run" */ '../views/ReportsHub/Run.vue'),
    },
];
